export default "__VITE_ASSET__D3Onc8qL__"